import React, { useState } from "react";
import { useEffect } from "react";
import { Icon } from "@aws-amplify/ui-react";
import { API } from "aws-amplify";
import { BsCheckLg } from "react-icons/bs";
import { listProducts } from "../graphql/queries";
import { Grid, View, useTheme, Heading, Text } from "@aws-amplify/ui-react";
import GeneralButton from "./GeneralButton";

export const CustomIconWithLibExample = () => {
  return <Icon as={BsCheckLg} style={{ color: "#2d7dd2", marginRight: "0.5em" }} />;
};

export function Welcome() {
  const { tokens } = useTheme();
  const [productCount, setProductCount] = useState(null);

  useEffect(() => {

    document.body.style.backgroundColor = "#ffffff";

    async function atLeastOneProduct() {
        const apiData = await API.graphql({
          query: listProducts,
          variables: {
            filter: {
              _deleted: { ne: true }
            }
          }
        });
        setProductCount(apiData.data.listProducts.items.length);
      }

    atLeastOneProduct();

    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  return (
    <div
      style={{
        zoom: "80%",
        fontFamily: "Arial, sans-serif",
        minHeight: "100vh",
        overflowY: "auto", // Enable scrolling if content overflows
        padding: "1em",
        backgroundColor: "transparent",
      }}
    >
      <Grid
        templateColumns="1fr"
        gap="1.5em" // Reduce gap between sections
        style={{
          maxWidth: "900px", // Limit overall width
          margin: "0 auto", // Center content horizontally
          paddingBottom: "1.5em",
        }}
      >
        {/* Section: Header */}
        <View
          style={{
            textAlign: "center",
            padding: "1.5em", // Reduce padding
            borderRadius: "8px", // Slightly smaller border radius
            backgroundColor: tokens.colors.neutral[10],
          }}
        >
          <Heading level={2} style={{ fontSize: "1.8em", marginBottom: "0.5em" }}>
            Benvenuto in Merum!
          </Heading>
          <Text style={{ fontSize: "1em", color: tokens.colors.font.secondary }}>
            Portiamo i migliori vini e distillati italiani negli Stati Uniti.
          </Text>
        </View>

        {/* Section: How it Works */}
        <View
          style={{
            backgroundColor: tokens.colors.neutral[10],
            padding: "1.5em", // Reduce padding
            borderRadius: "8px",
          }}
        >
          <Heading level={3} style={{ fontSize: "1.5em", marginBottom: "1em" }}>
            Come funziona
          </Heading>
          <Text style={{ fontSize: "1em", marginBottom: "1em" }}>
            <CustomIconWithLibExample />
            <strong>Carica il tuo portafoglio:</strong> Presenta gratuitamente i tuoi prodotti al
            nostro network di distributori.
          </Text>
          <Text style={{ fontSize: "1em", marginBottom: "1em" }}>
            <CustomIconWithLibExample />
            <strong>Ricevi notifiche di interesse:</strong> Quando un distributore mostra interesse,
            verrai informato immediatamente per valutare la richiesta.
          </Text>
          <Text style={{ fontSize: "1em" }}>
            <CustomIconWithLibExample />
            <strong>Entra su Merum:</strong> Scegli uno dei pacchetti a disposizione per accedere
            alla nostra piattaforma e concludere l’accordo.
          </Text>
        </View>

        {/* Section: Contact and CTA */}
        <View
          style={{
            textAlign: "center",
            padding: "1.5em", // Reduce padding
            borderRadius: "8px",
            backgroundColor: tokens.colors.neutral[10],
          }}
        >
          <Heading level={3} style={{ fontSize: "1.5em", marginBottom: "1em" }}>
            Hai domande?
          </Heading>
          <Text style={{ fontSize: "1em", marginBottom: "1.5em" }}>
            Puoi organizzare una call con Francesco qui:{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://calendly.com/merum-francesco/30min"
              style={{ color: "#2d7dd2", textDecoration: "none" }}
            >
              Organizza una call
            </a>.
          </Text>

          
          
          {productCount === null ? ( // Render a loading indicator while productCount is null
            <>
            </>
          ) : productCount < 1 ? (
            <>
              <Heading level={3} style={{ fontSize: "1.5em", marginBottom: "1em" }}>
                Confermi che non esporti attualmente negli Stati Uniti e sei pronto a procedere?
              </Heading>
              {/* Centered Button */}
              <div style={{ display: "flex", justifyContent: "center", marginTop: "1em" }}>
                <GeneralButton width="240px" text="Inizia Ora!" url="/addproduct" />
              </div>
            </>
          ) : (
            <br></br>
          )}


        </View>
      </Grid>
    </div>
  );
}
